<template>
  <a-modal
    v-model:open="visible"
    title="Edit"
    @cancel="handleCancel"
    @ok="handleSave"
    okText="save"
    :confirmLoading="saveLoading"
    :maskClosable="false"
    width="600px"
  >
    <div class="edit-tags-content">
      <div>
        <div class="current-tags-section">
          <h4>
            <!-- <span class="required-field">*</span>  -->
            StoreID:</h4>
          <div class="marketplace-info-flex">
            <a-input
            v-model:value="storeID"
            placeholder="Enter storeID"
          
            :maxlength="50"
          />
            
          </div>
        </div>
      </div>
      <!-- 当前标签显示 -->
       <div>
        <div class="marketplace-info">
          <h4>Marketplace:</h4>
          <div class="marketplace-info-flex">
            <Icon :name="countryCode(recordData.countryCode)?.icon"></Icon>
              {{ countryCode(recordData.countryCode)?.host }}
            
          </div>
        </div>
       </div>
      <div class="current-tags-section">
        <h4>tags:</h4>
        <div class="tags-container">
          <a-tag
            v-for="tag in currentTags"
            :key="tag"
            closable
            @close="removeTag(tag)"
            color="blue"
            class="tag-item"
          >
            {{ tag }}
          </a-tag>
        </div>
      </div>

      <!-- 添加新标签 -->
      <div class="add-tag-section">
        <h4>Add new tag:</h4>
        <div class="add-tag-input">
          <a-input
            v-model:value="newTag"
            placeholder="Enter new associate tag"
            @press-enter="addTag"
            :maxlength="50"
          />
          <a-button 
            type="primary" 
            @click="addTag"
            :disabled="!newTag.trim()"
            class="add-btn"
          >
            add
          </a-button>
        </div>
      </div>

   
    </div>
  </a-modal>
</template>

<script setup>
import { ref, defineEmits, defineExpose } from 'vue'
import { message } from 'ant-design-vue'
import { associateTagsApi } from '@/server/publisher/associateTags'
import { COUNTRY_BASE } from '~/contants/common'
import Icon from '~/components/Icon.vue'

const emit = defineEmits(['refresh'])
const storeID = ref('')
// 响应式数据
const visible = ref(false)
const recordData = ref({})
const currentTags = ref([])
const newTag = ref('')
const saveLoading = ref(false)
const countryCode =(countryCode)=> {
  return COUNTRY_BASE.find(item => item.countryCode === countryCode)
}
// 打开弹窗
const open = (record) => {
  recordData.value = { ...record }
  if (record && record.associateTags) {
    currentTags.value = [...record.associateTags]
  } else {
    currentTags.value = []
  }
  storeID.value = record.storeId
  visible.value = true
}

// 关闭弹窗
const close = () => {
  visible.value = false
  resetForm()
}

// 重置表单
const resetForm = () => {
  newTag.value = ''
  recordData.value = {}
  currentTags.value = []
}

// 验证标签格式
const validateTag = (tag) => {
  if (!tag || tag.trim().length === 0) {
    message.error('Tag cannot be empty') 
    return false
  }
  
  if (tag.length > 50) {
    message.error('Tag length cannot exceed 50 characters')
    return false
  }
  
  // 检查是否包含特殊字符（允许字母、数字、连字符、下划线）
  const regex = /^[a-zA-Z0-9\-_]+$/
  if (!regex.test(tag)) {
    message.error('Tag can only contain letters, numbers, hyphens, and underscores')
    return false
  }
  
  // 检查是否已存在
  if (currentTags.value.includes(tag.trim())) {
    message.error('Tag already exists')
    return false
  }
  

  
  return true
}

// 添加标签
const addTag = () => {
  const tag = newTag.value.trim()
  
  if (!validateTag(tag)) {
    return
  }
  
  currentTags.value.push(tag)
  newTag.value = ''
  // message.success('Tag added successfully') 
}

// 删除标签
const removeTag = (tag) => {
  const index = currentTags.value.indexOf(tag)
  if (index > -1) {
    currentTags.value.splice(index, 1)
 
  }
}

// 取消操作
const handleCancel = () => {
  close()
}

// 保存操作
const handleSave = async () => {
  saveLoading.value = true
  
  try {
    // 这里可以调用API保存标签
    
    await associateTagsApi.addAssociateTag({
      countryCode: recordData.value.countryCode,
      associateTags: currentTags.value,
      storeId: storeID.value
    })
    
    message.success('Tag saved successfully')
    close()
    
    // emit刷新事件
    emit('refresh')
  } catch (error) {
    message.error('Save failed, please try again')
    console.error('Save tags error:', error)
  } finally {
    saveLoading.value = false
  }
}

// 暴露方法给父组件
defineExpose({
  open,
  close
})
</script>

<style scoped lang="less">
.required-field{
  color: #ff4d4f;
}
.marketplace-info{
  display: flex;
  align-items: center;

  .marketplace-info-flex{
    display: flex;
    align-items: center;
    gap: 5px;
  }
  h4{
    margin-right: 10px;
  }
  margin-bottom: 24px;
  .icon{
    width: 20px;
    height: 20px;
  }
}
.edit-tags-content {
  .current-tags-section,
  .add-tag-section {
    margin-bottom: 24px;
    
    h4 {
      margin-bottom: 12px;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
    }
  }
  
  .tags-container {
    min-height: 60px;
    padding: 12px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    background-color: #fafafa;
    
    .tag-item {
      margin: 4px 8px 4px 0;
      padding: 4px 8px;
      font-size: 14px;
      
      &:hover {
        opacity: 0.8;
      }
    }
    
    &:empty::before {
      content: "No tags";
      color: #999;
      font-style: italic;
    }
  }
  
  .add-tag-input {
    display: flex;
    gap: 8px;
    
    .ant-input {
      flex: 1;
    }
    
    .add-btn {
      flex-shrink: 0;
    }
  }
  
  .tag-rules {
    margin-top: 20px;
    
    :deep(.ant-alert-description) {
      white-space: pre-line;
    }
  }
}
</style>
